import Vue from 'vue';

export default ({ $api, store }) => {
  $api.register('classification', '/web/public/classification', request => ({
    get: (path, payload) => request('GET', `/${path}`, payload),
  }));

  store.registerModule(
    'classification',
    {
      namespaced: true,
      state: () => ({}),
      getters: {},
      mutations: {
        /**
         * Set state property if it exists
         * @param {Object} state
         * @param {Object} payload
         */
        SET(state, { key, value, locale = store.getters['classification/locale'] }) {
          if (key in state) Vue.set(state[key], locale, value);
        },
      },
    },
    {
      preserveState: process.browser && !process.env.SPA,
    }
  );
};
